module.exports = __webpack_public_path__ + "media/chinese.5d50263d.mp3";